import { render } from "./video-call.vue?vue&type=template&id=05447628"
import script from "./video-call.vue?vue&type=script&lang=js"
export * from "./video-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__